// extracted by mini-css-extract-plugin
export var aircallIframe = "_mt-3";
export var fabContainer = "_mt-5";
export var fabRinging = "_mt-6";
export var loadingOverlay = "_mt-4";
export var pulse = "_mt-7";
export var widgetContent = "_mt-2";
export var widgetPanel = "_mt-0";
export var widgetPanelExpanded = "_mt-1";